var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-custom",style:(_vm.theme.header.image == '' ? _vm.headerColor : _vm.headerImage)},[_c('img',{class:`logo-custom ${_vm.getClassPostion(_vm.theme.logo.position)}`,attrs:{"src":`${
        _vm.restaurant.logo
          ? 'htttp://localhost:3333/logos/' + _vm.restaurant.logo
          : 'htttp://localhost:3333/logos/logo.png'
      }`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }